import React from 'react';
import { Navigate } from 'react-router-dom';
import { useSelector } from "react-redux";
import Cookies from 'js-cookie';

function AuthGuardingSuperAdmin({ children }) {
    const token = Cookies.get('authToken');
    const isLoggedIn = useSelector((state) => state.userStore.isLoggedIn);
    const user = useSelector((state) => state.userStore.user);
    const isAuthLoading = useSelector((state) => state.userStore.isAuthLoading);

    if (isAuthLoading) {
        return <div>Loading...</div>;
    }

    if (!token || !isLoggedIn || !user || !user.isSuperAdmin) {
        return <Navigate to={'/'} />;
    }

    return children;
}

export default AuthGuardingSuperAdmin;
